import * as angularPlatformBrowser from "@angular/platform-browser";
import * as angularPlatformBrowserAnimations from "@angular/platform-browser/animations";

// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};

window["ng"].platformBrowser = angularPlatformBrowser;
window["ng"].platformBrowser.animations = angularPlatformBrowserAnimations;

export { angularPlatformBrowser, angularPlatformBrowserAnimations };
